import { gql } from "apollo-boost";

export const GET_ARTICLE = (id) => gql`
  query GET_ARTICLE {
    article(id_article: ${id}) {
      id_article
      name
      id_article_type {
        name
      }
      is_prototype
      date
      in_use
    }
  }
`;

export const GET_ARTICLES = (id_entity) => gql`
  query GET_ARTICLES {
    articles(id_entity: ${id_entity}) {
      id_article
      name
      id_article_type {
        name
      }
      is_prototype
      date
      in_use
    }
  }
`;

export const GET_ARTICLE_DATA = (id) => gql`
  query GET_ARTICLES {
    articlePropertiesValues(id_article: ${id}) {
      value
    	tag
    }
  }
`;

export const GET_ARTICLE_PROP_VALUE = (id, tag) => gql`
  query GET_ARTICLES {
    articlePropertyValue(id_article: ${id}, tag:  ${tag}) {
      value
    	tag
    }
  }
`;

export const GET_ARTICLE_TYPES = gql`
  query GET_ARTICLE_TYPES {
    articleTypes {
      id_article_type
      name
    }
  }
`;

export const GET_ARTICLE_PROPS = gql`
  query GET_ARTICLE_PROPS {
    articleTypes {
      id_article_type
      name
    }
  }
`;
